import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-stat-card',
  templateUrl: './stat-card.component.html',
  styles: [],
})
export class StatCardComponent implements OnInit {
  @Input() icon;
  @Input() value;
  @Input() title;
  @Input() bgColor = '#009ed8';
  @Input() fontColor = '#005b7c';
  @Input() titleColor = '#212121';

  constructor() {}

  ngOnInit() {}
}
